<template>
	<div class="d-flex flex-column ao-drag-n-drop-collapse ">
		
		<div class="d-flex align-center ao-text-secondary-color-700 mt-2"
			style="cursor: pointer;"
			@click="toggleShowContent(true)">
			<ao-icon iconColor="textSecondary"
				iconName="dragNDrop" />
			<ao-icon iconName="groupOpen"
				size="small"
				class="ao-drag-n-drop-collapse-icon mr-1"
				:class="{'rotated' : showContent }"  />
			<ao-checkbox
				:modelValue="checked"
				color="secondary"
				@change="$emit('update:checked', $event)"
			>
				<span>{{title}}</span>
			</ao-checkbox>
			<v-spacer/>
		</div>
		<div style="position: relative">
			<div ref="colapse"
				class="ao-drag-n-drop-collapse-content pl-3" >
				<slot/>
			</div>
		</div>
		<v-divider class="mt-2"/>
	</div>
</template>
<script>
export default {

	name: 'AoDragNDropCollapse',
	components: {},
	props: {
		title: String,
		checked: Boolean
	},

	emits: {},

	data: () => ({
		showContent: false,
	}),

	computed: {},
	created() {},
	mounted(){
		this.$refs.colapse.style.maxHeight='0px'
	},

	methods: {
		
		toggleShowContent(){
			this.showContent=!this.showContent;
			this.$nextTick(() => {
				if (this.showContent) {
					this.$refs.colapse.style.maxHeight = `${this.$refs.colapse.scrollHeight}px`
				} else {
					this.$refs.colapse.style.maxHeight = '0px'
				}
			})
		},
	}
}
</script>

<style lang="scss">
.ao-drag-n-drop-collapse{
	width:100%;
	.ao-drag-n-drop-collapse-icon{
	transition: 0.3s;
	&.rotated{
	transform: rotate(90deg)
	}
}
&-content{
	overflow: hidden;
	transition: max-height 0.3s ease-out;
}
}

</style>
